import { render, staticRenderFns } from "./Livreurs.vue?vue&type=template&id=0e90a2af&"
import script from "./Livreurs.vue?vue&type=script&lang=js&"
export * from "./Livreurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports